import { render, staticRenderFns } from "./LocaleChooseDialog.vue?vue&type=template&id=ef0a1bae"
import script from "./LocaleChooseDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./LocaleChooseDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports